import { getAdminPermission } from 'API/AdminUser';
import { useQuery } from 'hooks/useCustomQuery';

export const useGetAdminPermission = (currentCompany, accountScope) => {
    return useQuery({
        queryKey: ['permissionSets'],
        queryFn: () => getAdminPermission({ accountScope, currentCompany }),
        enabled: Boolean(currentCompany),
        onSuccess: (data) => {
            return data.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },
        refetchOnWindowFocus: false,
    });
};
